import React from "react";
import { Button } from "../../../../core/components/Button";
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";
import { useTableImageActions } from "../../../../core/hooks/useTableImageActions";
import { ArrowRightIcon } from "../../../../core/icons/ArrowRight";
import { CheckIcon } from "../../../../core/icons/Check";
import { CircleLoading } from "../../../../core/icons/CircleLoading";
import { CopyIcon } from "../../../../core/icons/Copy";
import { DownloadIcon } from "../../../../core/icons/Download";

interface RenderTableProps {
	result: { participants: string[]; prize: string[] }[];
}

export const RenderTable = React.forwardRef<HTMLDivElement, RenderTableProps>(({ result }, ref) => {
	const size = window.innerWidth > 769 ? 2 : 20;
	const { isLoadingTableCopied, isTableCopied, copyTableAsImage, downloadTableAsImage } = useTableImageActions(ref, size);

	return (
		<>
			<div
				ref={ref}
				className={`overflow-x-auto p-4 shadow-[0px_1px_10px_rgba(0,0,0,0.1)] w-full rounded-lg ${result.length > 0 ? "animate-scaleIn" : "hidden"}`}
			>
				<table className="w-full">
					<thead>
						<tr className="w-full">
							<th className="text-center px-4 py-4 text-gray-500 font-semibold border-b w-1/2">
								<TextComponent variant="h4">Ganador</TextComponent>
							</th>
							<th className="text-center px-4 py-4 text-gray-500 font-semibold border-b"></th>
							<th className="text-center px-4 py-4 text-gray-500 font-semibold border-b w-1/2">
								<TextComponent variant="h4">Premio</TextComponent>
							</th>
						</tr>
					</thead>
					<tbody>
						{result.map((item, index) => (
							<tr
								key={index}
								className="text-center w-full text-gray-800"
							>
								<td className="px-4 py-4 border-b w-1/2">
									{item.participants.map((participant, participantIndex) => (
										<TextComponent
											key={participantIndex}
											variant="h5"
										>
											{participant}
											{participantIndex < item.participants.length - 1 && <br />}
										</TextComponent>
									))}
								</td>
								<td className="px-4 py-4 border-b text-orange-500">
									<div className="flex justify-center">
										<ArrowRightIcon />
									</div>
								</td>
								<td className="px-4 py-4 border-b w-1/2">
									{item.prize.map((prize, prizeIndex) => (
										<TextComponent
											key={prizeIndex}
											variant="h5"
										>
											{prize}
											{prizeIndex < item.prize.length - 1 && <br />}
										</TextComponent>
									))}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
			{result.length > 0 && (
				<Row
					className="gap-2 font-bold"
					responsiveCol
					flexible
				>
					<Button
						className="md:w-1/2"
						color="green"
						onClick={downloadTableAsImage}
					>
						<Row
							className="gap-1"
							crossAxisAlignment="center"
							mainAxisAlignment="center"
						>
							<DownloadIcon className="w-5 h-5" />
							<span>Descargar Tabla</span>
						</Row>
					</Button>
					<Button
						className="max-md:order-first md:w-1/2"
						color="blue"
						onClick={copyTableAsImage}
						isDisabled={isTableCopied}
					>
						<Row
							className="gap-1"
							crossAxisAlignment="center"
							mainAxisAlignment="center"
						>
							{isTableCopied ? (
								<CheckIcon className="w-5 h-5" />
							) : (
								<>
									{isLoadingTableCopied ? (
										<CircleLoading
											className="w-5 h-5"
											strokeWidth={12}
										/>
									) : (
										<CopyIcon className="w-5 h-5" />
									)}
								</>
							)}
							<span>{isTableCopied ? "¡La tabla ha sido copiada!" : `${isLoadingTableCopied ? "Copiando Tabla" : "Copiar Tabla como Imagen"}`}</span>
						</Row>
					</Button>
				</Row>
			)}
		</>
	);
});
